import $ from 'jquery';

$(() => {
  if ($('.form__field_role_checkbox').length) {
    // Hide all child option containers by default
    $('.child-options').hide();

    // When a parent checkbox is toggled
    $(document).on(
      'change',
      '.form__checkbox input[type="checkbox"]',
      function () {
        var $checkbox = $(this);
        var id = $checkbox.attr('id');
        var $childGroup = $('.child-options[data-parent="' + id + '"]');

        if ($childGroup.length) {
          if ($checkbox.is(':checked')) {
            $childGroup.slideDown(200);
          } else {
            // Uncheck all children if parent unchecked
            $childGroup.find('input[type="checkbox"]').prop('checked', false);
            $childGroup.slideUp(200);
          }
        }
      }
    );

    // On load, show any child groups for pre-checked parents
    $('.form__checkbox input[type="checkbox"]:checked').each(function () {
      var id = $(this).attr('id');
      $('.child-options[data-parent="' + id + '"]').show();
    });
  }
});
